import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { MenuItemComponentType } from "../../../../../constants";
import { LocalizationMessages } from "../../../../../localization/messages";
import { MenuActionCreators } from "../../../../../redux/action-creators";
import { MenuSelectors } from "../../../../../redux/selectors";
import { Item } from "../../../Models";
import { useKambiCategoryItems } from "./useKambiCategoryItems";

export const useKambiMenuItemsPC = trackingInfo => {
  const { visibleCategories, hiddenCategories } = useKambiCategoryItems();

  const menuItems = useSelector(MenuSelectors.menuItems);
  const dispatch = useDispatch();
  useEffect(() => {
    const quickLinkItems = getPCKambiMenuItems(
      visibleCategories,
      hiddenCategories,
      trackingInfo
    );

    if (quickLinkItems && quickLinkItems.length) {
      dispatch(MenuActionCreators.setMenuItems(quickLinkItems));
    }
  }, [dispatch, visibleCategories, hiddenCategories, trackingInfo]);

  return menuItems;
};

const getPCKambiMenuItems = (
  menuCategories,
  hiddenCategories,
  trackingInfo
) => {
  if (!menuCategories || !menuCategories.length > 0) return null;

  let allSportsItems = hiddenCategories || [];

  let menuItemsList = menuCategories.map(menuItem => {
    const item = menuItem;
    const hasChildren = menuItem.items?.length > 0;
    const menuItemProps = {
      item,
      automationId: menuItem.termKey,
      hasArrow: hasChildren,
      trackingInfo
    };

    const componentType = hasChildren
      ? MenuItemComponentType.ExpandableSportCategoryMenuItem
      : MenuItemComponentType.SportCategoryMenuItem;

    return {
      key: `menu-item-${item.fullURL}-${item.ID || item.sportID}`,
      props: menuItemProps,
      componentType
    };
  });

  if (!allSportsItems.length) return menuItemsList;

  const allSportsMenuItem = {
    key: "menu-item-all-sports",
    props: {
      item: new Item(
        {
          ID: "-",
          termKey: "all-sports",
          title: LocalizationMessages.allSports,
          iconKey: "more",
          items: allSportsItems,
          termKeyPrefix: "all-sports"
        },
        true
      ),
      automationId: "uc-all-sports",
      trackingInfo
    },
    componentType: MenuItemComponentType.KambiAllSportsMenuItem
  };

  return [...menuItemsList, allSportsMenuItem];
};
